
import Survey from '@/views/survey'
import ListSurvey from '@/views/survey/list'
import CreateSurvey from '@/views/survey/create'
import EditSurvey from '@/views/survey/edit'
import ShowSurvey from '@/views/survey/show'

export default {
  path: 'survey',
  redirect: '/survey/list',
  name: 'Survey',
  component: Survey,
  children: [
    {
      path: 'list',
      name: 'Survey list',
      component: ListSurvey
    },
    {
      path: 'show/:survey_id',
      name: 'Show',
      component: ShowSurvey
    },
    {
      path: 'create',
      name: 'Create',
      component: CreateSurvey
    },
    {
      path: ':survey_id/edit',
      name: 'Edit',
      component: EditSurvey
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/surveys/index.js